import { CreditApi } from '@bpm-web-app/create-api-sdk';
import { createConfig } from '../../config';

export class Credits {
    static client = new CreditApi(createConfig);

    static getCredits = () => Credits.client.getCredits();
}
